import { twMerge } from 'tailwind-merge';
import { useActiveTrial } from '@witmetrics/data-store';
import { useToggle } from '@/hooks/useToggle';
import { formatTrialTimeRemaining, isActiveTrial } from '@/utils/trials';
import { ClockIcon } from '@/icons';
import TrialConversionDialog from '@/dialogs/TrialConversionDialog';
import { classes } from './utils';

export type TrialCountdownProps = {
  className?: string;
};

export default function TrialCountdown({ className }: TrialCountdownProps) {
  const activeTrial = useActiveTrial();
  const [isDialogOpen, toggleDialog] = useToggle();

  const handleOpenDialog = () => toggleDialog(true);

  const handleCloseDialog = () => toggleDialog(false);

  const timeRemaining = formatTrialTimeRemaining(activeTrial?.timeRemaining);
  if (!isActiveTrial(activeTrial) || !timeRemaining) return null;

  return (
    <>
      <button
        className={twMerge(classes.button, className)}
        aria-label="trial time remaining"
        onClick={handleOpenDialog}>
        <ClockIcon />
        <span>{timeRemaining} left</span>
      </button>
      {isDialogOpen && <TrialConversionDialog onClose={handleCloseDialog} />}
    </>
  );
}
